import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {gsap, TimelineMax} from "gsap";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritModel} from "../../TrueGritModel";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TrueGritAvalancheFillUpReelsPresentation implements FlowStatePresentation {

    private _controller:FlowStateController;
    private _fillUpResponse:boolean = false;
    private _tl: gsap.core.Timeline;

    public start(flowStateController:FlowStateController) {
        TrueGritModel.previousReelsAfterCollapse = JSON.parse(JSON.stringify(TrueGrit.model.data.reelsAfterCollapse));

        this._controller = flowStateController;
        this._fillUpResponse = true;
        this.checkToStartFillUp();//Got server response
    }

    public checkToStartFillUp():void {
        this._tl = gsap.timeline();

        if(TrueGrit.model.avalancheCollapseComplete && this._fillUpResponse) {
            TrueGrit.model.avalancheCollapseComplete = false;
            this._fillUpResponse = false;
            const tl:gsap.core.Timeline = gsap.timeline({onComplete : () => this.complete()});

            // #416, #472
            tl.add(() => this._controller.setSkipCallback(() => this.skip()), 0.1);

            tl.add(TrueGrit.allReelsView.topReelModel.getFillUpReelAnimation(), 0);

            if (TrueGrit.model.gameData.xSplits){
                tl.add(TrueGrit.allReelsView.bottomReelModel.getFillUpReelAnimation(TrueGrit.model.reelSplitLongReel), 0);
            }else{
                tl.add(TrueGrit.allReelsView.bottomReelModel.getFillUpReelAnimation(), 0);
            }

            let nearWinDelay: number = 0,
                previousReelFillUpDurations: number[] = [0, 0, 0, 0, 0, 0];
            for(let i:number = 0; i < TrueGrit.allReelsView.mainReelModels.length; i++) {
                const fillUpReelAnimation:TimelineMax = new TimelineMax();

                fillUpReelAnimation.add(TrueGrit.allReelsView.mainReelModels[i].getFillUpReelAnimation());
                previousReelFillUpDurations[i] = fillUpReelAnimation.totalDuration();

                if (TrueGrit.model.gritGirlNearWinReels[i - 1] || TrueGrit.model.scatterNearWinReels[i - 1]) {
                    nearWinDelay += previousReelFillUpDurations[i - 1] - 0.2;
                }

                tl.add(fillUpReelAnimation, nearWinDelay);
            }

            // #105
            tl.add(() => TrueGrit.reelBackgroundView.turnOffAllTheBulletHoles());

            if(tl.duration() == 0) {
                tl.add(gsap.to(this, {duration : 0.001}));
            }

            this._tl = tl;
        }
    }

    private complete():void{
        this._controller.finish();
    }

    // #416
    private skip(): void {
        // #472
        if (!TrueGrit.anticipationView.isAnticipating) {
            this._controller.setSkipCallback(() => this.skip());
            return;
        }

        if (this._tl) {
            this._tl.timeScale(5);
        }
    }
}